import React from "react";
import {useFormik} from "formik";
import {ReCodeBody} from "../../interfaces/auth.insterface";
import {MDBBtn, MDBContainer, MDBInput} from "mdb-react-ui-kit";
import * as Yup from 'yup';
import {Alert, Grid, Typography} from "@mui/material";
import { useParams } from 'react-router-dom';
import {postCodeRegister, CodigoResgiser} from "../../services/auth_request";
import { useNavigate } from 'react-router-dom';


const ReCode:React.FC = ()=>{
    const { email } = useParams();
    const navigate = useNavigate();

    const formik = useFormik<ReCodeBody>({
        initialValues:{
            code: ''
        },
        onSubmit: async (values) => {
            if (email){
                const body:CodigoResgiser = {
                codigo: Number(values.code),
                email
            }
            const response = await postCodeRegister(body)
            if(response === 201) navigate('/login')
            }

        },
        validationSchema: Yup.object({
          code: Yup.string()
            .required('El código es obligatorio')
            .matches(/^\d{6}$/, 'Debe contener exactamente 6 dígitos numéricos'), // Regex clave
        }),
    })

    return <>
        <br/>
        <br/><br/>
        <br/>
        <MDBContainer>
            <Grid container direction={"row"} spacing={4} justifyContent={"center"} xs={12}>
                <Grid item xs alignItems={'center'} alignContent={'center'}>
                    <Typography fontWeight={700} variant='h5' textAlign={"center"}>Ingrese el Código</Typography>
                    <Typography variant='subtitle1' textAlign={"center"}>Introduce el código de verificación enviado a
                        tu correo.</Typography>
                </Grid>
                <Grid item>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container xs={12} direction={"row"}
                              sx={{
                                  justifyContent: "center",
                                  alignItems: "center",
                              }}
                        >
                            <Grid item xs={6}>
                                <MDBInput

                                    wrapperClass='mb-1'
                                    label='Code'
                                    name='code'
                                    id='code'
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    autoComplete={"off"}
                                    value={formik.values.code}
                                    type='text'
                                    maxLength={6}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {formik.touched.code && formik.errors.code ? (
                                    <Alert variant="standard" severity="error">{formik.errors.code} </Alert>
                                ) : null}
                            </Grid>
                            <Grid item xs={6}>
                                <MDBBtn className="mb-4" type='submit' disabled={!formik.isValid || !formik.dirty}>Validar</MDBBtn>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </Grid>


        </MDBContainer>


    </>
}

export default ReCode